module.exports = __webpack_public_path__ + "img/will_n.8f5b2b43.png";